import { createApp } from 'vue'
import './style.css'
import App from './App.vue'


import './scss/styles.scss'
import * as bootstrap from 'bootstrap'
import '/node_modules/@fortawesome/fontawesome-pro/css/all.css';

import store from '/src/store.js';

import router from "./routeur.js"; // Import the router instance

import naive from 'naive-ui'

import {installLogger} from './plugins/logger.js'

const app = createApp(App)

installLogger(app)

app.use(router).use(store)
  .use(naive)
  .mount('#app')
